<div class="flex-direction-column height-100 page" style="width: calc(100% - 25px);">
  <div class="titulo-container">
    <app-titulo
      [titulo]="fluxoNome ?? 'Voltar'"
      [foraAppComponent]="true"
      [confirmarRetorno]="alteracaoService.isCamposAlteracao()">
    </app-titulo>
    @if(fluxoNome){
        <img (click)="copiarUUID()" (keydown.enter)="copiarUUID()" tabindex="0" role="button" class="imagem-frasco" src="../../../assets/icones/frasco_roxo.svg" matTooltip="Copiar" alt="Copiar UUID">
    }
  </div>

  @if (carregando) {
    <div class="flex center-center height-100 flex-direction-column gap-15">
      <mat-spinner diameter="48"></mat-spinner>
      <span class="descricao-titulo-node">Carregando fluxo...</span>
    </div>
  } @else {
  <f-flow #flowContainer fDraggable fConnectable>
    <f-background>
      <f-circle-pattern [radius]="24" color="rgba(153, 61, 245, 0.18)"></f-circle-pattern>
    </f-background>
    <f-canvas #flowCanvas fZoom fZoomMinimum="0.1" fZoomMaximum="2" fZoomStep="0.1" fZoomDblClickStep="0.3" (fCanvasChange)="onCanvasChange($event)">
      @for (conn of connections; track conn.id) {
        <f-connection [fOutputId]="conn.sourceOutputId" [fInputId]="conn.targetInputId" class="arrow-connection"></f-connection>
      }
      @for (node of nodes; track node.id) {
        <div [ngClass]="$index === 0 ? 'caixa-node-first' : 'caixa-node'" fNode
          [id]="node.id"
          fDragHandle
          [fNodePosition]="node.position"
          fNodeOutput
          [fOutputId]="node.outputId || ''"
          fOutputConnectableSide="right"
          fNodeInput
          (fNodePositionChange)="onNodeMovedComId($event, node.id)"
          [fInputId]="node.inputId"
          fInputConnectableSide="left">
          <div class="node-inner flex-direction-column">
            <div class="flex-direction-row align-center justify-between">
              <div class="flex-direction-row align-center gap-10" style="margin-right: 10px">
                <img [src]="getIconTipo(node.tipoEtapa!) + ($index === 0 ? '-white' : '') + '.svg'" [matTooltip]="getLabel(node.tipoEtapa!)" [alt]="getLabel(node.tipoEtapa!)" style="transform: scale(1.5)" />
              </div>

              <div class="flex-direction-row align-center gap-5">
                <span class="titulo-node ellipse" [matTooltip]="node.title">{{node.title}}</span>
                <app-button-padrao style="transform: scale(.9)" [iconSrc]="$index === 0 ? 'icones/edit-white' : 'icones/edit'" iconSrcExtensao=".svg" width="30px"
                     height="30px" backgroundColor="transparent" widthIcon="22px" heightIcon="22px" (buttonClick)="abrirEdicao(node)"></app-button-padrao>

                @if (validaRemoveNode(node,$index)) {
                  <app-button-padrao icon="close" color="var(--primary)" width="30px" height="30px"
                       backgroundColor="transparent" fontSize="27px" (buttonClick)="removeNode(node)"></app-button-padrao>
                }
              </div>
            </div>
            <div [ngClass]="$index === 0 ? 'divider-white': 'divider-primary'"></div>
            <div class="flex-direction-column descricao-wrapper">
              <span class="descricao-titulo-node">Descrição</span>
              <p class="descricao-node">{{node.description}}</p>
            </div>
            @if (temPai(node)) {
              <button class="side-button left" (click)="inserirEntrePaiEAtual(node)">
                <div><mat-icon>add</mat-icon></div>
              </button>
            }
            @if (podeCriarAvanco(node)) {
              <button class="side-button right" (click)="addNodeOnSide(node)">
                <div><mat-icon>add</mat-icon></div>
              </button>
            }
          </div>
        </div>
      }
    </f-canvas>

    <div class="flow-zoom-toolbar" fLockedContext fDragBlocker>
      <button type="button" class="flow-zoom-btn" matTooltip="Diminuir zoom"
              (mousedown)="iniciarZoomOutContinuo()" (mouseup)="pararZoomContinuo()" (mouseleave)="pararZoomContinuo()">
        <mat-icon>remove</mat-icon>
      </button>
      <span class="flow-zoom-value">{{ zoomPercentual }}%</span>
      <button type="button" class="flow-zoom-btn" matTooltip="Aumentar zoom"
              (mousedown)="iniciarZoomInContinuo()" (mouseup)="pararZoomContinuo()" (mouseleave)="pararZoomContinuo()">
        <mat-icon>add</mat-icon>
      </button>
      <div class="flow-zoom-divisor"></div>
      <button type="button" class="flow-zoom-btn" matTooltip="Ajustar à tela" (click)="flowCanvas.fitToScreen({x: 60, y: 60}, true)">
        <mat-icon>fit_screen</mat-icon>
      </button>
      <button type="button" class="flow-zoom-btn" matTooltip="Redefinir zoom" (click)="flowCanvas.resetScaleAndCenter(true)">
        <mat-icon>restart_alt</mat-icon>
      </button>
    </div>
  </f-flow>
  <img src="./assets/botao-save.svg" class="botao-add cursor-pointer" alt="Salvar fluxo" tabindex="0" role="button" (click)="salvarFluxo()" (keydown.enter)="salvarFluxo()" />
  }
</div>
